<template>
  <div class="navigation-container">
    <Tab
      left
      :selected="udSelected"
      title="UD"
      @click.native="toggleUdSelected(true)"
    />
    <Tab
      right
      :selected="!udSelected"
      title="RETUR"
      @click.native="toggleUdSelected(false)"
    />
    <div
      class="user-icon"
      @click="onUserIconClick()"
    >
      <UserIcon />
    </div>
  </div>
</template>

<script>
import Tab from './Tab';
import UserIcon from '@/components/Icons/User';

export default {
  name: 'nav-bar',
  components: {
    Tab,
    UserIcon,
  },
  props: {
    onUserIconClick: {
      type: Function,
    },
    udSelected: Boolean,
    toggleUdSelected: Function,
  },
};
</script>

<style lang="scss" scoped>
.navigation-container {
  height: 122px;
  display: flex;
  align-items: flex-end;
  background-color: $primary-700;
  padding-left: 80px;
}
.user-icon {
  margin-left: auto;
  margin-right: 52px;
  align-self: center;
  cursor: pointer;
  opacity: 0.5;
}

.user-icon:hover {
  opacity: 0.8;
}

@media only screen and (max-width: $tablet-landscape-max-width ) {
  .user-icon {
    margin-right: 23px;
  }
}

@media only screen and (max-width: $mobile-max-width ) {
  .navigation-container {
    height: 90px;
    padding-left: 30px;
  .user-icon {
    margin-right: auto;
    margin-top: 14px;
  }
  }
}

</style>
